/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCalendarDeleted: {
  name: 'calendar-deleted';
  data: string;
} = {
  name: 'calendar-deleted',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 2a1 1 0 0 1 1 1v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 2 0v1h6V3a1 1 0 0 1 1-1ZM7 6v1a1 1 0 0 0 2 0V6h6v1a1 1 0 1 0 2 0V6h2v14H5V6h2Zm7.707 5.293a1 1 0 0 1 0 1.414L13.414 14l1.293 1.293a1 1 0 0 1-1.414 1.414L12 15.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 14l-1.293-1.293a1 1 0 1 1 1.414-1.414L12 12.586l1.293-1.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
